import ForumIcon from '@mui/icons-material/Forum';
import { Stack, Typography } from '@mui/material';
import PaiSpinningLoader from 'features/ui/base-components/pai-spinning-loader';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { TestContactPreview } from '../../campaign-builder.types';
import MessagePreviewCarousel from './message-preview-carousel';

interface Props {
  testContacts: TestContactPreview[];
  noNodesInFlow: boolean;
  notEveryNodeHasFunctionName: boolean;
  loading: boolean;
  activeTestContactIndex: number;
  activeMessageIndex: number;

  handleNextContact(): void;

  handlePrevContact(): void;

  handleNextMessage(): void;

  handlePrevMessage(): void;
}

const MessagePreview: React.FC<Props> = ({
  testContacts,
  noNodesInFlow,
  notEveryNodeHasFunctionName,
  loading,
  activeTestContactIndex,
  activeMessageIndex,
  handleNextContact,
  handlePrevContact,
  handleNextMessage,
  handlePrevMessage,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <>
      {loading ? (
        <Stack className={classes.loading} gap={3}>
          <Typography className={classes.greyText} align={'center'} mb={'8px'} style={{ maxWidth: '350px' }}>
            {t('preparingTestMessages')}
          </Typography>
          <PaiSpinningLoader size={'large'} />
          <Typography className={classes.greyText} align={'center'} style={{ maxWidth: '350px' }}>
            {t('processMayTake')}
          </Typography>
        </Stack>
      ) : _.isEmpty(testContacts) ? (
        <Stack className={classes.noPreview} gap={3}>
          <ForumIcon className={classes.icon} />
          <Typography className={classes.greyText} align={'center'} style={{ maxWidth: '400px' }}>
            {t('testYourCampaign')}
          </Typography>
          {noNodesInFlow ? <Typography className={classes.errorText}>{t('missingCampaignFlowNoNodes')}</Typography> : null}
          {notEveryNodeHasFunctionName ? <Typography className={classes.errorText}>{t('messageNodeMissingType')}</Typography> : null}
        </Stack>
      ) : (
        <div className={classes.messagePreview}>
          <MessagePreviewCarousel
            testContacts={testContacts}
            activeTestContactIndex={activeTestContactIndex}
            activeMessageIndex={activeMessageIndex}
            handleNextContact={handleNextContact}
            handlePrevContact={handlePrevContact}
            handleNextMessage={handleNextMessage}
            handlePrevMessage={handlePrevMessage}
          />
        </div>
      )}
    </>
  );
};

const useStyles = makeStyles()((theme) => ({
  messagePreview: {
    width: '100%',
    minHeight: '350px',
    borderRadius: '12px',
    background: '#FFF',
  },
  loading: {
    borderRadius: '12px',
    background: '#FFF',
    width: '100%',
    padding: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  noPreview: {
    borderRadius: '12px',
    background: '#FFF',
    width: '100%',
    padding: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    fontSize: theme.typography.pxToRem(60),
    color: theme.palette.greys.medium,
  },
  greyText: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.greys.medium,
  },
  errorText: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.error.main,
    maxWidth: '400px',
    textAlign: 'center',
  },
}));

export default MessagePreview;
